export const VALIDATION_DEBOUNCE_TIME = 600;

export const ATTRIBUTES_VALIDATION_STATE = {
  UNDEFINED: 'UNDEFINED',
  NOT_AVAILABLE: 'NOT_AVAILABLE',
  AVAILABLE: 'AVAILABLE'
};